import React,  { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , ButtonGroup,Box,FormControlLabel,  Switch , MenuItem ,LinearProgress, Typography,InputLabel,Button } from '@mui/material/';
import Cookies from 'js-cookie'

import axios from 'axios';

import Autorize from '../../components/ui/autorize';

import { DataGrid, GridToolbar,frFR } from '@mui/x-data-grid';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
export default function RapportFacture() {

    const [reportFacture, setReportFacture] = useState("");

    const [filtreComplete, setFiltreComplete] = useState(false); 
    const [filtreSolde0, setFiltreSolde0] = useState(false); 
    const [secteur, setSecteur] = useState(""); 
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");
    const [OptionStatusClub, setOptionStatusClub] = useState([]);
    const [displayProgress, setDisplayProgress] = useState(false); 


    /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})

   
    
  useEffect(() => {
        
             ReloadData();
            

    }, [filtreComplete,filtreSolde0]);


    
    
  function ReloadData() {
            if(autorize)           
            {          
                //, { headers: { Authorization: "Bearer "+ cookies }}
                MyAxios.get(process.env.REACT_APP_API + '/rapports/getReportFacture/' +  filtreComplete + '/' +filtreSolde0) //axios.defaults.withCredentials = true
                .then((res) => {      
                    setErrorAxios(false);
                    console.log(res);
                    setReportFacture(res.data);
                
                })
                .catch((error) => {
                    console.log(error)  
                    setErrorAxios(true);                 

                });
            }
  }
    

    
  function FfiltreComplete() {   

    setFiltreComplete(prevCheck => !prevCheck);
   

  }
    
  function FfiltreSolde0() {    
    setFiltreSolde0(prevCheck => !prevCheck);  

  }
    
    

    const columns = [           
        {      field: 'id',            headerName: 'id' ,   hide: true},        
        {      field: 'noClub',            headerName: 'Numéro de club' ,           width:150},           
        {      field: 'ClubLegalName', headerName: 'Nom légal', width:400},
        {      field: 'orderId',        headerName: 'Numéro facture',        width:110},       
        {      field: 'status', headerName: 'Statut facture', width:130},             
        {      field: 'invoice_date_timestamp',  headerName: 'Date facture',  width:160}, 
        {      field: 'name',    headerName: 'Item',    width:220},   
        {      field: 'quantity',   headerName: 'Quantité',   width:100},       
        {      field: 'price',   headerName: 'Prix',   width:100}, 
        {      field: 'total',   headerName: 'Solde',   width:100},          
    ];




    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };

    return (
            <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
                <Typography  variant='h6' ml={4} sx={{ fontSize: 17 }}>Toutes les factures détaillées</Typography>
            <form>
                   <Grid container direction="row" spacing={2}  m={2}>

                        <Grid item  direction="row" > 

                            
                            <FormControlLabel
                                value="start"
                                control={<Switch color="primary" />}
                                label="Facture non payé seulement"
                                labelPlacement="start"
                                onChange={FfiltreComplete}
                            />

                            <FormControlLabel
                                value="start"
                                control={<Switch color="primary" />}
                                label="Solde suppérieure à zéro"
                                labelPlacement="start"
                                onChange={FfiltreSolde0}
                            />


                            

                        </Grid>  

                        <Grid item container direction="row" > 

                          

                                <div style={{ height: '1000px', width: '90%' }}>
                            
                                    <DataGrid  localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                        rows={reportFacture}
                                        columns={columns}
                                        pageSize={100}
                                        rowsPerPageOptions={[100]}
                                        components={{ Toolbar: GridToolbar }}                                                                
                                    />
                                </div>
                        </Grid>                        
                </Grid>       
        </form>


        </div>
    );   

}

